import './PromptFlows.scss';

import { FC, useContext, useEffect, useState } from 'react';
import { AppContext } from 'components/AppContext/AppContext';
import ItemPager from 'components/ItemPager/ItemPager';
import { useDataSet } from 'customHooks/useDataSet';
import DataSetOperators, { SearchType, SortDirection } from 'interfaces/DataSetOperators';
import DataWrapper from 'interfaces/DataWrapper';
import { Entities } from 'models/Entities';
import { PromptFlow, TargetAction } from 'models/PromptFlow';
import { Form } from 'react-bootstrap';

import PromptFlowAction from '../PromptFlowAction/PromptFlowAction';

interface PromptFlowsProps {
  onExecuteAction: (action: any) => void;
}

const PromptFlows: FC<PromptFlowsProps> = ({ onExecuteAction }) => {
  const { configRepo, selectedProjectId } = useContext(AppContext);
  const pageSize = 10;
  const initialParams: DataSetOperators = {
    SortBy: 'Name',
    SortDirection: SortDirection.Asc,
    Top: pageSize,
    Skip: 0
  };
  const { dataSet, setOperators, operators } = useDataSet<PromptFlow>(
    configRepo!.SCHEDULE_API_BASE_URI,
    Entities.PromptFlows,
    selectedProjectId,
    initialParams,
  );
  const dataWrapper: DataWrapper<PromptFlow> =
    dataSet.responseData as DataWrapper<PromptFlow>;
  const promptFlows: PromptFlow[] = dataWrapper?.data;

  const [searchTerms, setSearchTerms] = useState('');
  const changePage = (pageNumber: number, skip: number) => {
    const ops = { ...operators };
    ops.Skip = skip;
    ops.Top = pageSize;
    setOperators(ops);
  };


  useEffect(() => {
    if (operators.ProjectId !== selectedProjectId) {
      const ops = { ...operators };
      ops.ProjectId = selectedProjectId;
      setOperators(ops);
    }
  }, [selectedProjectId]);

  useEffect(() => {
    const ops = { ...operators };
    ops.SearchProperty = 'Name|Description|MetaKeywords';
    ops.SearchType = SearchType.Contains;
    ops.SearchValue = searchTerms.toLowerCase();
    ops.Skip = 0;
    setOperators(ops);
  }, [searchTerms]);

  return (
    <div className="promptflows">
      <div className="promptflows-header">
        <h3>Prompt Chains &nbsp;<i className='bi bi-robot' /></h3>
      </div>
      <Form className="input-group">
        <input
          type="text"
          placeholder='Search...'
          className="form-control"
          onChange={(evt) => setSearchTerms(evt.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
          }}
          value={searchTerms} />
      </Form>
      <ItemPager
        viewAllLink='https://www.blabberjax.com/best-chat-gpt-prompts/'
        numberItemsPerPage={pageSize}
        totalNumberEntries={dataWrapper?.metaData?.totalRecordCount}
        onChangePageNumber={changePage} />
      <div className="promptflows-container mt-1">
        {promptFlows?.filter(pf => pf.targetAction !== TargetAction.GenerateThemeIdeas && pf.targetAction !== TargetAction.Dynamic)
          .map((promptFlow) =>
            <PromptFlowAction onExecuteAction={onExecuteAction} promptFlow={promptFlow} key={`pf-id-${promptFlow.id}`} />
          )}
      </div>
    </div>
  );
}

export default PromptFlows;